/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericDeleteUserSession} from '../api'

export const useMutationGenericDeleteUserSession = createReactQueryMutationHook('genericDeleteUserSession', genericDeleteUserSession)
